import React, { createContext, useState, useCallback, ReactNode } from 'react';
import { INotificationProps } from '../Notification';
export const NotificationProviderContext = /*#__PURE__*/createContext({});
export const NotificationProvider = ({
  children
}) => {
  const [notificationsList, setNotificationsList] = useState([]);
  const [current, setCurrent] = useState(null);
  const pushNotification = useCallback(items => {
    const clonedArray = [...notificationsList];
    items.forEach(notification => {
      const addableItemIndex = clonedArray.findIndex(item => {
        return typeof item !== 'undefined' ? item.id === notification.id : -1;
      });
      if (addableItemIndex === -1) {
        clonedArray.unshift(notification);
      }
    });
    setNotificationsList(clonedArray);
  }, [notificationsList]);
  const removeNotification = useCallback(id => {
    const clonedArray = [...notificationsList];
    const removableItemIndex = clonedArray.findIndex(item => {
      return typeof item !== 'undefined' ? item.id === id : -1;
    });
    if (removableItemIndex !== -1) {
      clonedArray.splice(removableItemIndex, 1);
    }
    setNotificationsList(clonedArray);
  }, [notificationsList]);
  const showNextElement = () => {
    const slicedArray = notificationsList.slice(1);
    setNotificationsList(slicedArray);
    if (typeof slicedArray[0] !== 'undefined') {
      setCurrent(slicedArray[0]);
    }
  };
  const NotificationProviderContextValue = {
    notificationsList,
    current,
    pushNotification,
    removeNotification,
    showNextElement
  };
  return /*#__PURE__*/React.createElement(NotificationProviderContext.Provider, {
    value: NotificationProviderContextValue
  }, children);
};